const GET_CART_DETAILS_FROM_API = 'GET_CART_DETAILS_FROM_API';
const FETCH_AUTOFILL_ADDRESS = 'FETCH_AUTOFILL_ADDRESS';
export const FETCH_AUTOFILL_ADDRESS_FAILURE = 'FETCH_AUTOFILL_ADDRESS_FAILURE';
export const FETCH_AUTOFILL_ADDRESS_SUCCESS = 'FETCH_AUTOFILL_ADDRESS_SUCCESS';
const FETCH_AUTOFILL_ADDRESS_UNIT = 'FETCH_AUTOFILL_ADDRESS_UNIT';
const FETCH_AUTOFILL_ADDRESS_UNIT2 = 'FETCH_AUTOFILL_ADDRESS_UNIT2';
const FETCH_APICONFIG = 'FETCH_APICONFIG';
export const FETCH_AUTOFILL_ADDRESS_UNIT_FAILURE = 'FETCH_AUTOFILL_ADDRESS_UNIT_FAILURE';
export const FETCH_AUTOFILL_ADDRESS_UNIT_SUCCESS = 'FETCH_AUTOFILL_ADDRESS_UNIT_SUCCESS';
export const FETCH_AUTOFILL_ADDRESS_UNIT_SUCCESS2 = 'FETCH_AUTOFILL_ADDRESS_UNIT_SUCCESS2';
export const SHOW_APPCONFIG_API_FAILURE = 'SHOW_APPCONFIG_API_FAILURE';
export const FETCH_APPCONFIG_API_SUCCESS = 'FETCH_APPCONFIG_API_SUCCESS';
const ASYNC_FETCH = 'ASYNC_FETCH';
const ASYNC_FETCH_SUCCESS = 'ASYNC_FETCH_SUCCESS';
const GET_CART_SUCCESS = 'GET_CART_SUCCESS';
const ERR_OCCURED = 'ERR_OCCURED';
const SHOW_CART = 'SHOWCART';
const UPDATE_SHOW_CART = 'UPDATE_SHOW_CART';
const SHOW_PAGE = 'SHOWPAGE';
const UPDATE_CART_PAGE = 'UPDATE_CART_PAGE';
const ADD_ACCESSORIES = 'ADD_ACCESSORIES';
const ADD_ON_ACCESS = 'ADD_ON_ACCESS';
const GET_REVIEW_ORDER = 'GET_REVIEW-ORDER';
const GET_DEVICE_SETUP = 'GET_DEVICE_SETUP';
const GET_VALIDATE_ORDER = 'GET_VALIDATE_ORDER';
const UPDATE_VALIDATE_ORDER = 'UPDATE_VALIDATE_ORDER';
const UPDATE_INSTALL_TYPE_SUUCESS = 'UPDATE_INSTALL_TYPE_SUUCESS';
const ENABLE_CNT_BTN = 'ENABLE_CNT_BTN';
const UPDATE_SAVE_CART = 'UPDATE_SAVE_CART';
const PROCEED_TO_NEXT = 'PROCEED_TO_NEXT';
const RESET_PROCEED_FLOW = 'RESET_PROCEED_FLOW';
const ERORR_CART = 'ERORR_CART';
const AUTOPAY_TEXT = 'AUTOPAY_TEXT';
const ADD_ACCESSORIES_MV = 'ADD_ACCESSORIES_MV';
const UPDATE_INSTALL_TYPE_SUUCESS_MV = 'UPDATE_INSTALL_TYPE_SUUCESS_MV';
const ASYNC_FETCH_SUCCESS_MV = 'ASYNC_FETCH_SUCCESS_MV';
const ABANDON_CART_CALL = 'ABANDON_CART_CALL';
const VALIDATECART_RESPONSE = 'VALIDATECART_RESPONSE';
const RESET_VALIDATE_CART = 'RESET_VALIDATE_CART';
const NEED_VALIDATE_CART = 'NEED_VALIDATE_CART';
const QUANTITY_CHANGED = 'QUANTITY_CHANGED';
const SHOW_CART_API_ERROR = 'SHOW_CART_API_ERROR';
const PREORDER = 'PREORDER';
const GET_SHIPPING_DET_FROM_API = 'GET_SHIPPING_DET_FROM_API';
const GET_DETAILS_SHIPPING_API_SUCCESS = 'GET_DETAILS_SHIPPING_API_SUCCESS';
const POST_SHIPPINGOPTION_SUCCESS = 'POST_SHIPPINGOPTION_SUCCESS';
const UPDATE_PROCESS_STEP_CART = 'UPDATE_PROCESS_STEP_CART';
const IS_COUPON_VALID = 'IS_COUPON_VALID';
const COUPIN_VALID_SUCCESS = 'COUPIN_VALID_SUCCESS';
const CLEAR_VALID_COUPON_RESPONSE = 'CLEAR_VALID_COUPON_RESPONSE';
const CLEAR_COUPON_VALUE = 'CLEAR_COUPON_VALUE';
const LOADING_DONE = 'LOADING_DONE';
const CONFIRMATION_RETRIEVE_CART = 'CONFIRMATION_RETRIEVE_CART';
const CART_INVALIDCASE_ERROR = 'CART_INVALIDCASE_ERROR';
const UPDATE_SAVE_CART_SUCCESS = 'UPDATE_SAVE_CART_SUCCESS';
const CHECKOUT_DETAILS = 'CHECKOUT_DETAILS';
const CHECKOUT_DETAILS_RESPONSE = 'CHECKOUT_DETAILS_RESPONSE';
const CHECKOUT_DETAILS_ERROR = 'CHECKOUT_DETAILS_ERROR';
const CHECKOUT_DETAILS_SUCCESS = 'CHECKOUT_DETAILS_SUCCESS';
export const GET_MINI_CART = 'GET_MINI_CART';
const POST_DATA_PRO_INSTALLATION_DEVICE_SETUP_SUCCESS = 'POST_DATA_PRO_INSTALLATION_DEVICE_SETUP_SUCCESS';
export const GET_MINI_CART_SUCCESS = 'GET_MINI_CART_SUCCESS';
export const GET_MINI_CART_ERROR = 'GET_MINI_CART_ERROR';
export const RESET_MINI_CART_STATUS = 'RESET_MINI_CART_STATUS';
export const IS_EMPTY_ADDRESS = 'IS_EMPTY_ADDRESS';
export const CEF_CART_ERROR = 'CEF_CART_ERROR';
export const DEFAULT_ERROR_MESSAGE = 'Looks like something went wrong. Please try again later.';
export const UPDATE_CART_API_SUCCESS = 'UPDATE_CART_API_SUCCESS';
export const UPDATE_USER_DATA = 'UPDATE_USER_DATA';
export const SETUP_LEARN_MORE = 'Learn more';
export const VALIDATE_ORDER_FAILED = 'VALIDATE_ORDER_FAILED';
export const SET_CART_ERROR_FOR_REVIEW_ORDER_PAGE = 'SET_CART_ERROR_FOR_REVIEW_ORDER_PAGE';
export {
  GET_CART_DETAILS_FROM_API,
  FETCH_AUTOFILL_ADDRESS,
  FETCH_AUTOFILL_ADDRESS_UNIT,
  FETCH_AUTOFILL_ADDRESS_UNIT2,
  FETCH_APICONFIG,
  ASYNC_FETCH,
  ASYNC_FETCH_SUCCESS,
  GET_CART_SUCCESS,
  ERR_OCCURED,
  SHOW_CART,
  UPDATE_SHOW_CART,
  SHOW_PAGE,
  UPDATE_CART_PAGE,
  ADD_ACCESSORIES,
  ADD_ON_ACCESS,
  GET_REVIEW_ORDER,
  GET_DEVICE_SETUP,
  GET_VALIDATE_ORDER,
  UPDATE_INSTALL_TYPE_SUUCESS,
  UPDATE_VALIDATE_ORDER,
  ENABLE_CNT_BTN,
  UPDATE_SAVE_CART,
  PROCEED_TO_NEXT,
  RESET_PROCEED_FLOW,
  ERORR_CART,
  AUTOPAY_TEXT,
  ADD_ACCESSORIES_MV,
  UPDATE_INSTALL_TYPE_SUUCESS_MV,
  ASYNC_FETCH_SUCCESS_MV,
  ABANDON_CART_CALL,
  VALIDATECART_RESPONSE,
  RESET_VALIDATE_CART,
  NEED_VALIDATE_CART,
  QUANTITY_CHANGED,
  SHOW_CART_API_ERROR,
  PREORDER,
  GET_SHIPPING_DET_FROM_API,
  GET_DETAILS_SHIPPING_API_SUCCESS,
  POST_SHIPPINGOPTION_SUCCESS,
  UPDATE_PROCESS_STEP_CART,
  IS_COUPON_VALID,
  COUPIN_VALID_SUCCESS,
  CLEAR_VALID_COUPON_RESPONSE,
  CLEAR_COUPON_VALUE,
  LOADING_DONE,
  CONFIRMATION_RETRIEVE_CART,
  CART_INVALIDCASE_ERROR,
  UPDATE_SAVE_CART_SUCCESS,
  CHECKOUT_DETAILS,
  CHECKOUT_DETAILS_RESPONSE,
  CHECKOUT_DETAILS_ERROR,
  CHECKOUT_DETAILS_SUCCESS,
  POST_DATA_PRO_INSTALLATION_DEVICE_SETUP_SUCCESS,
};
